import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { environment } from '../../../environment';
import { LayerService } from '../../../services/layer.service';
import { MapService } from '../../../services/map.service';
import { UserService } from '../../../services/user.service';
import { BaseComponent } from '../../base.component';
/* tslint:disable:template-cyclomatic-complexity */
var ShareMapComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ShareMapComponent, _super);
    function ShareMapComponent(_vcr, layerService, mapService, userService, changeRef, authService, loggingService) {
        var _this = _super.call(this, _vcr) || this;
        _this.layerService = layerService;
        _this.mapService = mapService;
        _this.userService = userService;
        _this.changeRef = changeRef;
        _this.authService = authService;
        _this.loggingService = loggingService;
        _this.outputSearchText = new Subject();
        _this.canViewUsers = false;
        _this.canViewCWOPAData = false;
        _this.searchPlaceholder = 'Email or Name';
        _this.closeShareMap = new EventEmitter();
        _this.openSaveMap = new EventEmitter();
        _this.email = {
            recipients: [],
            message: '',
            address: ''
        };
        _this.shared = false;
        _this.internalEmailOnly = true;
        _this.includeADGroups = false;
        _this.allowShareWithSelf = true;
        _this.success = false;
        _this.loadingEmails = false;
        _this.notifyUserByEmail = true;
        _this.PUBLIC_LAYER_NAMES = new Set([
            'View Public Data',
            'MapCore Public Layers',
            'Mapcore Public Layers'
        ]);
        _this.registerEvent('closeShareMap', _this.closeShareMap);
        _this.registerEvent('openSaveMap', _this.openSaveMap);
        var milliseconds = 500;
        _this.outputSearchText
            .pipe(debounceTime(milliseconds))
            .subscribe(function (searchText) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.shareCandidates = [];
                        if (!(searchText.length !== 0)) return [3 /*break*/, 3];
                        if (!(this.canViewUsers && searchText.endsWith('@pa.gov'))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.userService.registerUser(searchText)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.getUsers(searchText);
                        return [3 /*break*/, 4];
                    case 3:
                        this.shareCandidatesError = null;
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); });
        authService.permissions.subscribe(function (permissions) {
            _this.canViewUsers = permissions && permissions.includes('View Users');
            _this.canViewCWOPAData = permissions && permissions.includes('View CWOPA Data');
        });
        return _this;
    }
    Object.defineProperty(ShareMapComponent.prototype, "map", {
        get: function () {
            return this._map;
        },
        set: function (value) {
            if (!Array.isArray(value)) {
                value = value ? [value] : null;
            }
            this._map = value;
            this.setShareMapObject();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShareMapComponent.prototype, "mustSave", {
        get: function () {
            return this.requiresSave() && !this.requiresCopy();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShareMapComponent.prototype, "mustSaveUnsaved", {
        get: function () {
            return this.hasUnsaved() && !this.requiresCopy();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShareMapComponent.prototype, "requireSaveCopy", {
        get: function () {
            return this.requiresCopy();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShareMapComponent.prototype, "disableForm", {
        get: function () {
            return this.formDisabled();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShareMapComponent.prototype, "showAddButton", {
        get: function () {
            return this.showFreeFormButton();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShareMapComponent.prototype, "noRecipient", {
        get: function () {
            return !this.hasRecipients();
        },
        enumerable: true,
        configurable: true
    });
    ShareMapComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.authService.GetCurrentUser().subscribe(function (user) {
            _this.user = user;
        });
        this.loading = { status: false, text: 'Loading...' };
    };
    ShareMapComponent.prototype.ngAfterViewInit = function () {
        this.isReady();
    };
    ShareMapComponent.prototype.setShareMapObject = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.resetAlerts();
                        if (!this.map) return [3 /*break*/, 2];
                        this.shareObj = [];
                        _a = this;
                        return [4 /*yield*/, Promise.all(this.map.map(function (map) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var mapData;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.mapService.retrieveMap(map, this.user.id)];
                                        case 1:
                                            mapData = _a.sent();
                                            return [2 /*return*/, {
                                                    label: 'Map',
                                                    id: mapData.id,
                                                    data: mapData,
                                                    title: mapData.name
                                                }];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.shareObj = _b.sent();
                        this.loadMapUrls();
                        this.changeRef.detectChanges();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ShareMapComponent.prototype.loadMapUrls = function () {
        var e_1, _a;
        this.mapUrls = [];
        try {
            for (var _b = tslib_1.__values(this.shareObj), _c = _b.next(); !_c.done; _c = _b.next()) {
                var s = _c.value;
                this.mapUrls.push(this.mapService.getMapUrl(s.id));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    ShareMapComponent.prototype.hasRecipients = function () {
        return this.email.recipients.length > 0;
    };
    ShareMapComponent.prototype.requiresSave = function () {
        var e_2, _a;
        var retval = false;
        try {
            for (var _b = tslib_1.__values(this.shareObj), _c = _b.next(); !_c.done; _c = _b.next()) {
                var s = _c.value;
                if (!(!!s.id) || s.data.accessLevel !== 'OWNER') {
                    retval = true;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return retval;
    };
    ShareMapComponent.prototype.requiresCopy = function () {
        var e_3, _a;
        var retval = false;
        this.unownedMaps = [];
        try {
            for (var _b = tslib_1.__values(this.shareObj), _c = _b.next(); !_c.done; _c = _b.next()) {
                var s = _c.value;
                if (s.data.accessLevel === 'VIEWER') {
                    retval = true;
                    this.unownedMaps.push(s);
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return retval;
    };
    ShareMapComponent.prototype.selectShareMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.shareObj.length > 1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.multiShare()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.share()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ShareMapComponent.prototype.share = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_4, _a, data, recipients, sharedUserIds, errorArr, errorArr_1, errorArr_1_1, err;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.email.recipients || !this.email.recipients.length) {
                            return [2 /*return*/];
                        }
                        this.loading = { text: 'Sharing map...', status: true };
                        return [4 /*yield*/, this.hasUnshareableLayers()];
                    case 1:
                        if (_b.sent()) {
                            this.loading.status = false;
                            return [2 /*return*/];
                        }
                        data = this.shareObj.map(function (s) { return ({ title: s.title, message: _this.email.message }); });
                        recipients = this.constructRecipients(this.email.recipients);
                        sharedUserIds = this.map.map(function (u) { return (u.sharedWith || []).map(function (s) { return s.userId; }); });
                        errorArr = [];
                        return [4 /*yield*/, Promise.all(this.shareObj.map(function (s) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var sent;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.mapService.shareMap(s.id, { data: data, recipients: recipients }, this.notifyUserByEmail, sharedUserIds)];
                                        case 1:
                                            sent = _a.sent();
                                            if (sent) {
                                                this.updateSharedUsers(recipients.map(function (r) { return r.id; }));
                                            }
                                            else {
                                                errorArr.push("We are unable to share your " + s.label.toLowerCase() + " " + s.title.toLowerCase() + " at this time.");
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 2:
                        _b.sent();
                        if (errorArr.length === 1) {
                            this.error = "We are unable to share your " + errorArr[0].label.toLowerCase() + " " + errorArr[0].title.toLowerCase() + " at this time.";
                        }
                        else if (errorArr.length > 1) {
                            this.error = 'We are unable to share the following maps:';
                            try {
                                for (errorArr_1 = tslib_1.__values(errorArr), errorArr_1_1 = errorArr_1.next(); !errorArr_1_1.done; errorArr_1_1 = errorArr_1.next()) {
                                    err = errorArr_1_1.value;
                                    this.error += " " + err.label.toLowerCase() + err.title.toLowerCase();
                                }
                            }
                            catch (e_4_1) { e_4 = { error: e_4_1 }; }
                            finally {
                                try {
                                    if (errorArr_1_1 && !errorArr_1_1.done && (_a = errorArr_1.return)) _a.call(errorArr_1);
                                }
                                finally { if (e_4) throw e_4.error; }
                            }
                        }
                        else {
                            this.success = true;
                            this.shared = true;
                        }
                        this.loading.status = false;
                        this.resetForm();
                        return [2 /*return*/];
                }
            });
        });
    };
    ShareMapComponent.prototype.multiShare = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_5, _a, data, recipients, sharedUserIds, errorArr, allSharedMapIds, sent, errorArr_2, errorArr_2_1, err;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.email.recipients || !this.email.recipients.length) {
                            return [2 /*return*/];
                        }
                        this.loading = { text: 'Sharing map...', status: true };
                        return [4 /*yield*/, this.hasUnshareableLayers()];
                    case 1:
                        if (_b.sent()) {
                            this.loading.status = false;
                            return [2 /*return*/];
                        }
                        data = this.shareObj.map(function (s) { return ({ title: s.title, message: _this.email.message }); });
                        recipients = this.constructRecipients(this.email.recipients);
                        sharedUserIds = this.map.map(function (u) { return (u.sharedWith || []).map(function (s) { return s.userId; }); });
                        errorArr = [];
                        allSharedMapIds = [];
                        this.shareObj.map(function (s) { allSharedMapIds.push(s.id); });
                        return [4 /*yield*/, this.mapService.shareMaps(allSharedMapIds, { data: data, recipients: recipients }, this.notifyUserByEmail, sharedUserIds)];
                    case 2:
                        sent = _b.sent();
                        if (sent) {
                            this.updateSharedUsers(recipients.map(function (r) { return r.id; }));
                        }
                        else {
                            allSharedMapIds.forEach(function (map) {
                                errorArr.push("We are unable to share your " + map.label.toLowerCase() + " " + map.title.toLowerCase() + " at this time.");
                            });
                        }
                        if (errorArr.length === 1) {
                            this.error = "We are unable to share your " + errorArr[0].label.toLowerCase() + " " + errorArr[0].title.toLowerCase() + " at this time.";
                        }
                        else if (errorArr.length > 1) {
                            this.error = 'We are unable to share the following maps:';
                            try {
                                for (errorArr_2 = tslib_1.__values(errorArr), errorArr_2_1 = errorArr_2.next(); !errorArr_2_1.done; errorArr_2_1 = errorArr_2.next()) {
                                    err = errorArr_2_1.value;
                                    this.error += " " + err.label.toLowerCase() + err.title.toLowerCase();
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (errorArr_2_1 && !errorArr_2_1.done && (_a = errorArr_2.return)) _a.call(errorArr_2);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                        }
                        else {
                            this.success = true;
                            this.shared = true;
                        }
                        this.loading.status = false;
                        this.resetForm();
                        return [2 /*return*/];
                }
            });
        });
    };
    ShareMapComponent.prototype.updateSharedUsers = function (recipientUserIds) {
        var e_6, _a, e_7, _b;
        try {
            for (var _c = tslib_1.__values(this.map), _d = _c.next(); !_d.done; _d = _c.next()) {
                var map = _d.value;
                if (!map.sharedWith) {
                    map.sharedWith = [];
                }
                var _loop_1 = function (userId) {
                    if (!map.sharedWith.some(function (s) { return s.userId === userId; })) {
                        map.sharedWith.push({ userId: userId });
                    }
                };
                try {
                    for (var recipientUserIds_1 = tslib_1.__values(recipientUserIds), recipientUserIds_1_1 = recipientUserIds_1.next(); !recipientUserIds_1_1.done; recipientUserIds_1_1 = recipientUserIds_1.next()) {
                        var userId = recipientUserIds_1_1.value;
                        _loop_1(userId);
                    }
                }
                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                finally {
                    try {
                        if (recipientUserIds_1_1 && !recipientUserIds_1_1.done && (_b = recipientUserIds_1.return)) _b.call(recipientUserIds_1);
                    }
                    finally { if (e_7) throw e_7.error; }
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_6) throw e_6.error; }
        }
    };
    ShareMapComponent.prototype.hasUnshareableLayers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_8, _a, e_9, _b, mapIds, maps, unshareableMaps, layerMaps, layerIds, _loop_2, maps_1, maps_1_1, map, layers, parentLayerIds, parentLayers, _loop_3, layers_1, layers_1_1, layer;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.unshareableMaps = null;
                        mapIds = this.shareObj.map(function (m) { return m.id; });
                        return [4 /*yield*/, this.mapService.getMaps(mapIds, 'name, isPublic, layers { id, name }')];
                    case 1:
                        maps = _c.sent();
                        unshareableMaps = maps.map(function (m) { return ({ name: m.name, layers: [] }); });
                        layerMaps = {};
                        layerIds = [];
                        _loop_2 = function (map) {
                            var e_10, _a;
                            if (!map.isPublic) {
                                return "continue";
                            }
                            try {
                                for (var _b = tslib_1.__values(map.layers), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    var layer = _c.value;
                                    layerMaps[layer.id] = unshareableMaps.filter(function (um) { return um.name === map.name; })[0];
                                    layerIds.push(layer.id);
                                }
                            }
                            catch (e_10_1) { e_10 = { error: e_10_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_10) throw e_10.error; }
                            }
                        };
                        try {
                            for (maps_1 = tslib_1.__values(maps), maps_1_1 = maps_1.next(); !maps_1_1.done; maps_1_1 = maps_1.next()) {
                                map = maps_1_1.value;
                                _loop_2(map);
                            }
                        }
                        catch (e_8_1) { e_8 = { error: e_8_1 }; }
                        finally {
                            try {
                                if (maps_1_1 && !maps_1_1.done && (_a = maps_1.return)) _a.call(maps_1);
                            }
                            finally { if (e_8) throw e_8.error; }
                        }
                        if (!(layerIds.length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.layerService.getLayersFromApi(layerIds, 'id, parentId, name, permissions { name }, sources { sourceType }')];
                    case 2:
                        layers = _c.sent();
                        parentLayerIds = layers.map(function (l) { return l.parentId; });
                        return [4 /*yield*/, this.layerService.getLayersFromApi(parentLayerIds, 'id, name, permissions { name }')];
                    case 3:
                        parentLayers = _c.sent();
                        _loop_3 = function (layer) {
                            var permissions = layer.permissions;
                            if (layer.sources.every(function (s) { return s.sourceType === 'FEATURE_ENDPOINT'; })) {
                                return "continue";
                            }
                            if (layer.parentId) {
                                var parentLayer = parentLayers.filter(function (pl) { return pl.id === layer.parentId; })[0];
                                permissions = permissions.concat(parentLayer.permissions);
                            }
                            if (!permissions.some(function (p) { return _this.PUBLIC_LAYER_NAMES.has(p.name); })) {
                                layerMaps[layer.id].layers.push(layer.name);
                            }
                        };
                        try {
                            for (layers_1 = tslib_1.__values(layers), layers_1_1 = layers_1.next(); !layers_1_1.done; layers_1_1 = layers_1.next()) {
                                layer = layers_1_1.value;
                                _loop_3(layer);
                            }
                        }
                        catch (e_9_1) { e_9 = { error: e_9_1 }; }
                        finally {
                            try {
                                if (layers_1_1 && !layers_1_1.done && (_b = layers_1.return)) _b.call(layers_1);
                            }
                            finally { if (e_9) throw e_9.error; }
                        }
                        _c.label = 4;
                    case 4:
                        unshareableMaps = unshareableMaps.filter(function (um) { return um.layers.length > 0; });
                        unshareableMaps.sort(function (a, b) { return a.name.localeCompare(b.name); });
                        if (unshareableMaps.length > 0) {
                            this.unshareableMaps = unshareableMaps;
                            return [2 /*return*/, true];
                        }
                        else {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ShareMapComponent.prototype.mapRecipient = function (recipient) {
        return { email: recipient.email, id: recipient.id || null };
    };
    ShareMapComponent.prototype.constructRecipients = function (recipients) {
        var _this = this;
        var e_11, _a;
        var retVal = [];
        try {
            for (var recipients_1 = tslib_1.__values(recipients), recipients_1_1 = recipients_1.next(); !recipients_1_1.done; recipients_1_1 = recipients_1.next()) {
                var recipient = recipients_1_1.value;
                if (!recipient.groupMembers) {
                    this.addRecipientIfNotPresent(this.mapRecipient(recipient), retVal);
                }
                else {
                    recipient.groupMembers.forEach(function (x) { return _this.addRecipientIfNotPresent(_this.mapRecipient(x), retVal); });
                }
            }
        }
        catch (e_11_1) { e_11 = { error: e_11_1 }; }
        finally {
            try {
                if (recipients_1_1 && !recipients_1_1.done && (_a = recipients_1.return)) _a.call(recipients_1);
            }
            finally { if (e_11) throw e_11.error; }
        }
        return retVal;
    };
    ShareMapComponent.prototype.addRecipientIfNotPresent = function (recipient, emailList) {
        if (emailList.filter(function (x) { return x.email === recipient.email; }).length === 0) {
            emailList.push(this.mapRecipient(recipient));
        }
    };
    ShareMapComponent.prototype.addFreeFormRecipient = function (emailAddress) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var recipient_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.resetAlerts();
                        if (!(this.allowShareWithSelf || emailAddress !== this.user.emailAddress)) return [3 /*break*/, 5];
                        this.loadMessage = 'Verifying recipients';
                        return [4 /*yield*/, this.userService.verifyAccount(emailAddress)];
                    case 1:
                        recipient_1 = _a.sent();
                        if (!recipient_1) return [3 /*break*/, 3];
                        return [4 /*yield*/, Promise.all(this.shareObj.map(function (s) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var users, email, firstName, lastName, id;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.mapService.getMapUsers(s.id)];
                                        case 1:
                                            users = _a.sent();
                                            if (users.indexOf(recipient_1.email) === -1) {
                                                email = recipient_1.email, firstName = recipient_1.firstName, lastName = recipient_1.lastName, id = recipient_1.id;
                                                this.addRecipient({ email: email, firstName: firstName, lastName: lastName, id: id });
                                            }
                                            else {
                                                this.info = {
                                                    recipient: recipient_1.email
                                                };
                                                this.email.address = '';
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.error = "No user found for email address " + emailAddress;
                        this.email.address = '';
                        _a.label = 4;
                    case 4:
                        this.loadMessage = undefined;
                        return [3 /*break*/, 6];
                    case 5:
                        this.error = 'You may not share a map with yourself';
                        this.email.address = '';
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ShareMapComponent.prototype.showFreeFormButton = function () {
        return (/\S+@\S+\.\S+/i).test(this.inputSearchText || '');
    };
    ShareMapComponent.prototype.resetError = function () {
        this.error = undefined;
        this.unshareableMaps = null;
    };
    ShareMapComponent.prototype.resetWarning = function () {
        this.warn = undefined;
    };
    ShareMapComponent.prototype.resetSuccess = function () {
        this.success = undefined;
    };
    ShareMapComponent.prototype.resetInfo = function () {
        this.info = undefined;
    };
    ShareMapComponent.prototype.resetAlerts = function () {
        this.loadingEmails = false;
        this.resetError();
        this.resetWarning();
        this.resetSuccess();
        this.resetInfo();
    };
    ShareMapComponent.prototype.resetForm = function () {
        this.email.address = '';
        this.email.message = '';
        this.email.recipients.length = 0;
    };
    ShareMapComponent.prototype.addRecipient = function (recipient) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.resetAlerts();
                        return [4 /*yield*/, Promise.all(this.shareObj.map(function (s) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var existingUsers, recipients, emails;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.mapService.getMapUsers(s.id)];
                                        case 1:
                                            existingUsers = _a.sent();
                                            if (!existingUsers.some(function (val) { return val.id === recipient.id; })) {
                                                recipients = this.email.recipients;
                                                emails = recipients.map(function (r) {
                                                    return r.email;
                                                });
                                                if (emails.indexOf(recipient.email) < 0) {
                                                    recipients.push(recipient);
                                                }
                                                this.email.address = '';
                                            }
                                            else {
                                                this.info = {
                                                    recipient: recipient.email
                                                };
                                                this.email.address = null;
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ShareMapComponent.prototype.removeRecipient = function (recipient) {
        var recipients = this.email.recipients, index = recipients.indexOf(recipient);
        if (index >= 0) {
            recipients.splice(index, 1);
        }
    };
    ShareMapComponent.prototype.addMember = function (group, member) {
        this.addRecipient(member);
        group.splice(group.indexOf(member), 1);
    };
    ShareMapComponent.prototype.removeMember = function (group, member) {
        group.splice(group.indexOf(member), 1);
    };
    ShareMapComponent.prototype.getUsers = function (searchText) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingEmails = true;
                        return [4 /*yield*/, Promise.all(this.shareObj.map(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var maxRows, results, er_1;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            maxRows = 200;
                                            _a.label = 1;
                                        case 1:
                                            _a.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this.userService.searchUsers(searchText, maxRows, this.includeADGroups, !this.canViewCWOPAData)];
                                        case 2:
                                            results = _a.sent();
                                            this.shareCandidates = results;
                                            return [3 /*break*/, 4];
                                        case 3:
                                            er_1 = _a.sent();
                                            this.shareCandidatesError = 'An error occured';
                                            this.loggingService.Log('Error retrieving users', er_1);
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        this.loadingEmails = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ShareMapComponent.prototype.selectUser = function (user) {
        this.email.recipients.push(user);
        this.inputSearchText = '';
        this.shareCandidates = [];
        this.shareCandidatesError = null;
    };
    ShareMapComponent.prototype.formatUserSearchResult = function (result) {
        if (result) {
            if (typeof result === 'string') {
                return result;
            }
            else {
                if (result.id < 0) {
                    var count = result.groupMembers.length;
                    return result.firstName + " ( " + count + "  Members)";
                }
                else {
                    return result.firstName + "  " + result.lastName + " ( " + result.email + " )";
                }
            }
        }
        return '[Error when formatting result]';
    };
    ShareMapComponent.prototype.hasRecipientsError = function () {
        return !this.email.recipients.length;
    };
    ShareMapComponent.prototype.hasFormError = function () {
        return this.requiresSave() || this.hasRecipients();
    };
    ShareMapComponent.prototype.hasUnsaved = function () {
        // return !this.requiresSave();
        return false;
    };
    ShareMapComponent.prototype.saveMaps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mapIds, appId, mapsCopied;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.mustSave) return [3 /*break*/, 1];
                        //for single map that needs saved, close the window and open the saveMaps component
                        this.close();
                        this.openSaveMap.emit();
                        return [3 /*break*/, 3];
                    case 1:
                        if (!(this.unownedMaps.length > 0)) return [3 /*break*/, 3];
                        this.loading = { status: true, text: 'Creating Copies...' };
                        mapIds = this.unownedMaps.map(function (x) { return x.id; });
                        appId = environment.appId;
                        return [4 /*yield*/, this.mapService.copyMaps(mapIds, appId)];
                    case 2:
                        mapsCopied = _a.sent();
                        this.map = mapsCopied;
                        this.loading.status = false;
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ShareMapComponent.prototype.close = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.inputSearchText = '';
                this.closeShareMap.emit();
                return [2 /*return*/];
            });
        });
    };
    ShareMapComponent.prototype.formDisabled = function () {
        return this.requiresCopy() || this.requiresSave();
    };
    return ShareMapComponent;
}(BaseComponent));
export { ShareMapComponent };
export var EmailRegex = new RegExp(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi);
